/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Token_InvalidInputs */

const en_error_token_invalid = /** @type {(inputs: Error_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has expired or was already used.`)
};

/**
* | output |
* | --- |
* | "This link has expired or was already used." |
*
* @param {Error_Token_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_token_invalid = /** @type {((inputs?: Error_Token_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Token_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_token_invalid(inputs)
});